import { ApiService } from "./AbstractApiService";
export class FileAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: FileAPI | null;
  constructor() {
    super("dms");
  }
  public async uploadFile(file: File, config?: any) {
    const formData = new FormData();
    formData.append("content", file);
    return this.post(
      "file?json=" + encodeURI(JSON.stringify(config)),
      formData,
      {
        method: "POST",
        headers: {
          "content-type": "multipart/form-data",
        },
      }
    );
  }
  public async fetchImage(path: string) {
    return this.get(`file/url/${path}`, {
      responseType: "arraybuffer",
      headers: { Accept: "*/*" },
    });
  }
  public async fetchImageWithMetaData(path: string) {
    return this.get(`file/${path}`, {
      responseType: "arraybuffer",
      headers: { Accept: "*/*" },
    });
  }
  public async deleteImage(path: string) {
    return this.delete(`file/${path}`).then((response) => response);
  }
}
